export default __webpack_public_path__ + "images/002.png";